const translate = {
  'Всего найдено': {
    ru: 'Всего',
    en: 'Total',
  },
};

export default translate;
